import Swiper from 'swiper';

export function aboutSlider() {

    if (window.innerWidth > 767) {
        return false;
    }

    let sliderAbout = new Swiper('.about-slider', {
        containerModifierClass: 'about-slider',
        wrapperClass: 'about-slider__wrapper',
        slideClass: 'about-slide',
        slideActiveClass: 'is-active',
        width: 280,
        pagination: {
            el: '.about-slider__pagination',
            type: 'bullets',
            bulletClass: 'about-slider__bullet',
            bulletActiveClass: 'about-slider__bullet_active',
            clickable: true,
        },
    });
}